import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from './../store'
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/auth/LoginView.vue'
import ForgotPassword from '@/auth/ForgotPassword.vue'
import IndexVehicule from '@/views/parc-auto/vehicules/IndexVehicule.vue'
import IndexIntervention from '@/views/parc-auto/interventions/IndexIntervention.vue'
import IndexClient from '../views/operations/clients/IndexClient.vue'
import IndexCourse from '../views/operations/courses/IndexCourse.vue'
import IndexReservation from '../views/operations/reservations/IndexReservation.vue'
import IndexPaiement from '../views/operations/paiements/IndexPaiement.vue'
import IndexProgramme from '../views/operations/programmes/IndexProgramme.vue'
import IndexAdresse from '../views/operations/adresses/IndexAdresse.vue'
import IndexFacture from '../views/comptabilite/factures/IndexFacture.vue'
import IndexAchat from '../views/comptabilite/achats/IndexAchat.vue'
import IndexOperation from '../views/comptabilite/operations/IndexOperation.vue'
import IndexPieceDeCaisse from '../views/comptabilite/pieces-de-caisse/IndexPieceDeCaisse.vue'
import AccountVerify from '@/auth/AccountVerify.vue'
import IndexGeoloc from '@/views/geolocalisation/IndexGeoloc.vue'
import IndexConfig from '../views/configurations/IndexConfig.vue'
import IndexConfigGeneral from '../views/configurations/general/IndexConfigGeneral.vue'
import IndexConfigVehicule from '../views/configurations/vehicules/IndexConfigVehicule.vue'
import IndexConfigInterventions from '../views/configurations/interventions/IndexConfigInterventions.vue'
import IndexConfigCourses from '../views/configurations/courses/IndexConfigCourses.vue'
import TableauDeBord from '../views/TableauDeBord.vue'
import IndexUtilisateur from '@/views/ressources-humaines/IndexUtilisateur.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/se-connecter',
    name: 'login',
    component: LoginView
  },
  {
    path: '/mot-de-passe-oublie',
    name: 'forgot_password',
    component: ForgotPassword
  },
  {
    path: '/verifier-mon-compte',
    name: 'account.verify',
    component: AccountVerify
  },
  {
    path: '/',
    name: 'accueil',
    component: HomeView
  },
  {
    path: '/tableau-de-bord',
    name: 'tableau-de-bord',
    component: TableauDeBord
  },
  {
    path: '/parc-auto/vehicules',
    name: 'vehicules',
    component: IndexVehicule
  },
  {
    path: '/parc-auto/interventions',
    name: 'interventions',
    component: IndexIntervention
  },
  {
    path: '/operations/clients',
    name: 'clients',
    component: IndexClient
  },
  {
    path: '/operations/courses',
    name: 'courses',
    component: IndexCourse
  },
  {
    path: '/operations/demandes',
    name: 'demandes',
    component: IndexReservation
  },
  {
    path: '/operations/adresses',
    name: 'adresses',
    component: IndexAdresse
  },
  {
    path: '/ressources-humaines',
    name: 'utilisateurs',
    component: IndexUtilisateur
  },
  {
    path: '/operations/paiements',
    name: 'paiements',
    component: IndexPaiement
  },
  {
    path: '/operations/calendrier',
    name: 'programmes',
    component: IndexProgramme
  },
  {
    path: '/comptabilite/factures',
    name: 'factures',
    component: IndexFacture
  },
  {
    path: '/comptabilite/achats',
    name: 'achats',
    component: IndexAchat
  },
  {
    path: '/comptabilite/pieces-de-caisse',
    name: 'pieces_de_caisse',
    component: IndexPieceDeCaisse
  },
  {
    path: '/comptabilite/journaux',
    name: 'journaux',
    component: IndexOperation
  },
  {
    path: '/geolocalisation',
    name: 'geolocalisation',
    component: IndexGeoloc
  },
  {
    path: '/configurations',
    component: IndexConfig,
    children: [
      {
        path: '',
        name: 'configurations',
        redirect: { name: 'configurations.general' }
      },
      {
        path: 'general',
        name: 'configurations.general',
        component: IndexConfigGeneral
      },
      {
        path: 'vehicules',
        name: 'configurations.vehicules',
        component: IndexConfigVehicule
      },
      {
        path: 'interventions',
        name: 'configurations.interventions',
        component: IndexConfigInterventions
      },
      {
        path: 'courses',
        name: 'configurations.courses',
        component: IndexConfigCourses
      }
    ]
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'forgot_password' && to.name !== 'login' && to.name !== 'register' && !store.getters.authenticated) next({ name: 'login' })
  // else if (to.name !== 'account.verify' && store.getters.authenticated) next({ name: 'account.verify' })
  else next()
})

export default router
